"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.assign.js");
var _react = _interopRequireWildcard(require("react"));
var _line = require("@nivo/line");
var _index = require("./index");
var _moment = _interopRequireDefault(require("moment"));
var _constants = require("../../utils/constants");
var _ChartTooltip = require("./ChartTooltip");
var _ChartParams = require("../../features/provider/ChartParams");
var _paulCorePackage = require("paul-core-package");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const DashedSolidLine = _ref => {
  let {
    series,
    lineGenerator,
    xScale,
    yScale
  } = _ref;
  return series.map(line => /*#__PURE__*/_react.default.createElement(_index.LineItem, {
    line: line,
    lineGenerator: lineGenerator,
    xScale: xScale,
    yScale: yScale,
    key: line.id
  }));
};
const CirculationChart = /*#__PURE__*/(0, _react.memo)(_ref2 => {
  let {
    data,
    rangeType,
    dateType,
    minTemperature,
    hoverLine,
    isPrediction = false,
    curve = _constants.curveTypes.linear
  } = _ref2;
  const {
    isDynamicHeight
  } = (0, _ChartParams.useChartParams)();
  const yScale = {
    type: 'linear',
    stacked: false,
    reverse: false,
    min: (0, _ChartParams.getHeightByFlag)({
      isDynamicHeight,
      value: 0
    }),
    max: (0, _ChartParams.getHeightByFlag)({
      isDynamicHeight,
      value: _constants.maxWaterTemperature
    })
  };
  const getMarkers = () => {
    const markers = [];
    if (data.length) {
      markers.push({
        axis: 'y',
        value: minTemperature,
        lineStyle: {
          stroke: hoverLine ? _index._lineTheme.disabledLine : _constants.lineColor.middleLine,
          strokeWidth: 2,
          opacity: 1
        }
      });
    }
    markers.push({
      axis: 'x',
      value: new Date((0, _moment.default)().hour(0).format('MM/DD/YYYY')),
      lineStyle: {
        stroke: _constants.lineColor.predictionColor,
        strokeWidth: 2,
        opacity: isPrediction ? 1 : 0
      },
      legend: 'today',
      textStyle: {
        transform: 'translate(-20px, -20px) rotate(0deg)',
        fill: _constants.lineColor.predictionColor,
        opacity: isPrediction ? 1 : 0
      }
    });
    return markers;
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "w-100 h-100 position-relative nivo-line-chart-separate-points ".concat(data.length ? 'nivo-line-transform-axis-top' : '')
  }, /*#__PURE__*/_react.default.createElement(_line.ResponsiveLine, {
    data: data,
    theme: _index._lineTheme,
    margin: {
      top: 35,
      right: 44,
      bottom: 60,
      left: 100
    },
    colors: {
      datum: 'color'
    },
    layers: ['grid', 'axes', 'areas', CustomLayerProps => /*#__PURE__*/_react.default.createElement(_index.PredictionZone, _extends({}, CustomLayerProps, {
      isPrediction: isPrediction
    })), 'markers', 'crosshair', DashedSolidLine, _index.EmptyZoneMesh, 'points', 'slices', 'mesh'],
    markers: getMarkers(),
    tooltip: PointTooltipProps => /*#__PURE__*/_react.default.createElement(_ChartTooltip.ChartTooltip, {
      PointTooltipProps: PointTooltipProps,
      dateType: dateType,
      data: data
    }),
    xFormat: "time:%Y-%m-%d",
    xScale: {
      type: 'time',
      format: '%Y-%m-%d %H:%M',
      useUTC: false,
      precision: _constants.rangeTypesByKey[rangeType]
    },
    yFormat: " >-.1f",
    yScale: yScale,
    curve: curve,
    axisTop: data.length ? {
      format: t => (0, _index.getTimeFormatTitle)(t, rangeType, dateType),
      orient: 'bottom',
      tickSize: 0,
      tickPadding: 0,
      tickRotation: 0
    } : null,
    axisBottom: {
      format: t => (0, _index.getTimeFormat)(t, rangeType, dateType),
      orient: 'bottom',
      tickSize: 0,
      tickPadding: 10,
      tickRotation: 0,
      tickValues: (0, _index.getTickValues)({
        dateType
      })
    },
    axisLeft: {
      format: value => "".concat(value, " \xB0C"),
      orient: 'left',
      tickSize: 0,
      tickPadding: 18,
      tickRotation: 0
    },
    axisRight: null,
    enableGridX: false,
    lineWidth: 1,
    enablePoints: false,
    areaOpacity: 0.05,
    crosshairType: "x",
    useMesh: true,
    animate: false
  }));
}, _paulCorePackage.functions.areEqual);
var _default = exports.default = CirculationChart;